import { Action, Reducer } from "redux";
import { produce } from "immer";
import { DispatchActions } from "../actions/commonActions";
import { actionTypes } from "../types/commonTypes";
import { IDelegateeUser } from "src/Core/ViewModels/User/UserViewModel";
import { IMenuSection } from "src/Core/ViewModels/SideMenu/SideMenuModel";

export interface ICommonState {
    forceUpdate: number;
    mailboxUserData: IDelegateeUser | null;
    helpCenterUrl: string;
    mailboxUserList: IDelegateeUser[];
    sideMenuData: IMenuSection[];
    isLoading: boolean;
    cpaPortalUrl: string;
}

const unloadedState: ICommonState = {
    forceUpdate: 0,
    mailboxUserData: null,
    helpCenterUrl: "",
    mailboxUserList: [],
    sideMenuData: [],
    isLoading: false,
    cpaPortalUrl: "",
};

export const reducer: Reducer<ICommonState> = produce(
    (draftState: ICommonState = unloadedState, incomingAction: Action) => {
        const action = incomingAction as DispatchActions;
        switch (action.type) {
            case actionTypes.REQUEST_FORCE_UPDATE:
                draftState.forceUpdate++;
                break;
            case actionTypes.RECEIVE_HELP_CENTER_URL:
                draftState.helpCenterUrl = action.payload;
                break;
            case actionTypes.REQUEST_OTHERS_INBOX_LIST:
                draftState.isLoading = true;
                return draftState;
            case actionTypes.RECEIVE_OTHERS_INBOX_LIST:
                draftState.isLoading = false;
                draftState.mailboxUserList = action.payload;
                return draftState;
            case actionTypes.COMPLETE_OTHERS_INBOX_LIST:
                draftState.isLoading = false;
                return draftState;
            case actionTypes.SAVE_OTHER_USER_DATA:
                draftState.mailboxUserData = action.payload;
                return draftState;
            case actionTypes.REMOVE_OTHER_USER_DATA:
                draftState.mailboxUserData = null;
                return draftState;
            case actionTypes.REQUEST_SIDE_MENU_DATA:
                draftState.isLoading = true;
                return draftState;
            case actionTypes.RECEIVE_SIDE_MENU_DATA:
                draftState.sideMenuData = action.payload;
                return draftState;
            case actionTypes.COMPLETE_SIDE_MENU_DATA:
                draftState.isLoading = false;
                return draftState;
            case actionTypes.REQUEST_CPA_PORTAL_URL:
                draftState.isLoading = true;
                return draftState;
            case actionTypes.RECEIVE_CPA_PORTAL_URL:
                draftState.isLoading = false;
                draftState.cpaPortalUrl = action.payload;
                return draftState;
            default:
                return draftState;
        }
    }
);
